/* Collection cards: tap a colour swatch to see that colour.
   The card's photo changes to the colour's own photo, and its links open the
   product in that colour, keeping the size the card was showing when the
   colour comes in it. Works on any .pmo-card, including ones drawn later by
   assets/pmo-collection.js (filters, sorting, "Show more"). */
(function () {
  if (window.__pmoCardSwatches) return;
  window.__pmoCardSwatches = true;

  var css = document.createElement("style");
  css.textContent =
    ".pmo-card .pmo-sw{cursor:pointer;transition:box-shadow .15s}" +
    ".pmo-card .pmo-sw:hover{box-shadow:0 0 0 2px #fff,0 0 0 3px #8a94a3}" +
    ".pmo-card .pmo-sw.is-on{box-shadow:0 0 0 2px #fff,0 0 0 3px #3a506b}" +
    ".pmo-card .pmo-sw:focus-visible{outline:2px solid #3a506b;outline-offset:2px}";
  document.head.appendChild(css);

  var cache = {};
  function product(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    var m = a && /\/products\/([^?#/]+)/.exec(a.getAttribute("href"));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function withVariant(href, id) {
    return /[?&]variant=\d*/.test(href) ? href.replace(/([?&]variant=)\d*/, "$1" + id) : href + (href.indexOf("?") > -1 ? "&" : "?") + "variant=" + id;
  }
  function pick(card, sw) {
    var handle = handleOf(card), name = sw.getAttribute("title");
    if (!handle || !name) return;
    Array.prototype.forEach.call(card.querySelectorAll(".pmo-sw"), function (s) {
      var on = s === sw;
      s.classList.toggle("is-on", on);
      s.setAttribute("aria-pressed", on ? "true" : "false");
    });
    product(handle).then(function (p) {
      if (!p || !p.variants) return;
      var ci = -1;
      (p.options || []).forEach(function (o, i) { if (ci < 0 && /colou?r/i.test(typeof o === "string" ? o : o.name)) ci = i; });
      if (ci < 0) return;
      var inCol = p.variants.filter(function (v) { return v.options[ci] === name; });
      if (!inCol.length) return;
      var link = card.querySelector('a[href*="/products/"]');
      var cur = (/[?&]variant=(\d+)/.exec(link.getAttribute("href")) || [])[1];
      var curV = p.variants.filter(function (v) { return String(v.id) === cur; })[0];
      var same = curV ? inCol.filter(function (v) { return v.options.every(function (o, i) { return i === ci || o === curV.options[i]; }); })[0] : null;
      var v = same || inCol.filter(function (x) { return x.available; })[0] || inCol[0];
      var withImg = (v.featured_image ? v : inCol.filter(function (x) { return x.featured_image; })[0]);
      var img = card.querySelector(".pmo-ph img");
      if (withImg && img) {
        var src = String(withImg.featured_image.src || withImg.featured_image).replace(/^https?:/, "");
        img.removeAttribute("srcset");
        img.src = src + (src.indexOf("?") > -1 ? "&" : "?") + "width=600";
      }
      Array.prototype.forEach.call(card.querySelectorAll('a[href*="/products/"]'), function (a) {
        a.setAttribute("href", withVariant(a.getAttribute("href"), v.id));
      });
    });
  }
  function swatchFrom(e) {
    var sw = e.target && e.target.closest ? e.target.closest(".pmo-card .pmo-sw") : null;
    return sw && sw.closest(".pmo-card") ? sw : null;
  }
  document.addEventListener("click", function (e) {
    var sw = swatchFrom(e);
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    pick(sw.closest(".pmo-card"), sw);
  }, true);
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var sw = swatchFrom(e);
    if (!sw) return;
    e.preventDefault();
    pick(sw.closest(".pmo-card"), sw);
  });
  // Make the swatches reachable by keyboard and announced as buttons.
  function prime(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(".pmo-card .pmo-sw:not([role])"), function (s) {
      s.setAttribute("role", "button");
      s.setAttribute("tabindex", "0");
      s.setAttribute("aria-label", "Show in " + (s.getAttribute("title") || "this colour"));
      s.setAttribute("aria-pressed", "false");
    });
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; prime(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { prime(); });
  else prime();
})();
